import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CommonModule, NgClass } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
    selector: 'setting',
    templateUrl: './theme-customizer.html',
    standalone: true,
    imports: [
        NgClass,
        NgScrollbarModule,
        FormsModule,
        CommonModule,
        SharedModule
    ],
})
export class ThemeCustomizerComponent implements OnInit {
    store: any;
    showCustomizer = false;
    constructor(public storeData: Store<any>, public router: Router) {
    }

    ngOnInit() {
        this.initStore();
    }

    initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    reloadRoute() {
        window.location.reload();
        this.showCustomizer = true;
    }
}
